<template>
  <div class="d-flex align-items-center">
    <b-badge
      class="sr-status-badge"
      :class="{'badge-vt-success':status.code === 'true', ' badge-vt-pending':status.code === 'false'}"
      pill
    >
      {{ text }}
    </b-badge>
  </div>
</template>

<script>

export default {
    name: 'ReadIndicatorBadge',
    props: {
        status: { type: Object, required: true }
    },
    computed: {
        text() {
            return this.status.code === 'true' ? this.$tc('global.read', 1) : this.$tc('global.unread', 1)
        }
    }
}

</script>

<style scoped lang="scss">

    .sr-status-badge {
        min-width: 70px;
    }

</style>
